<template>
  <div class="PageProfile">
    <h1 class="text-h5 mb-6">Meu Perfil</h1>

    <!-- Informações do usuário -->
    <v-card class="mb-4 elevation-2">
      <v-card-title class="subtitle-1 font-weight-bold">Informações</v-card-title>
      <v-card-text>
        <v-list dense>
          <v-list-item>
            <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Nome</v-list-item-subtitle>
              <v-list-item-title>{{ fullName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon><v-icon>mdi-email</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>E-mail</v-list-item-subtitle>
              <v-list-item-title>{{ user.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon><v-icon>mdi-badge-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Perfil</v-list-item-subtitle>
              <v-list-item-title>{{ profileLabel }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- Alterar nome -->
    <v-card class="mb-4 elevation-2">
      <v-card-title class="subtitle-1 font-weight-bold">Alterar Nome</v-card-title>
      <v-card-text>
        <v-form ref="nameForm" v-model="nameValid" lazy-validation>
          <v-text-field
            v-model="firstName"
            label="Nome"
            outlined
            dense
            :rules="[v => !!v || 'Nome é obrigatório']"
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="Sobrenome"
            outlined
            dense
            :rules="[v => !!v || 'Sobrenome é obrigatório']"
          ></v-text-field>
          <v-btn
            block
            color="primary"
            :disabled="savingName"
            :loading="savingName"
            @click="saveName"
          >
            Salvar nome
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Alterar senha -->
    <v-card class="elevation-2">
      <v-card-title class="subtitle-1 font-weight-bold">Alterar Senha</v-card-title>
      <v-card-text>
        <v-form ref="passwordForm" v-model="passwordValid" lazy-validation>
          <v-text-field
            v-model="currentPassword"
            label="Senha atual"
            type="password"
            outlined
            dense
            :rules="[v => !!v || 'Senha atual é obrigatória']"
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            label="Nova senha"
            type="password"
            outlined
            dense
            :rules="[v => !!v || 'Nova senha é obrigatória', v => v.length >= 6 || 'Mínimo 6 caracteres']"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            label="Confirmar nova senha"
            type="password"
            outlined
            dense
            :rules="[v => !!v || 'Confirmação é obrigatória', v => v === newPassword || 'As senhas não coincidem']"
          ></v-text-field>
          <v-btn
            block
            color="primary"
            :disabled="savingPassword"
            :loading="savingPassword"
            @click="savePassword"
          >
            Alterar senha
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { UserService } from '../../lib/spasms-control'
import { getToken, getUser, saveUser } from '../../utils'
import store from '../../store'

export default {
  name: 'PageProfile',
  data() {
    return {
      user: {},
      firstName: '',
      lastName: '',
      nameValid: false,
      savingName: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordValid: false,
      savingPassword: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success'
    }
  },
  computed: {
    fullName() {
      return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim()
    },
    profileLabel() {
      const type = this.user.profile && this.user.profile.profile_type
      return type === 'doctor' ? 'Médico' : 'Responsável'
    }
  },
  methods: {
    async saveName() {
      if (!this.$refs.nameForm.validate()) return

      this.savingName = true
      const service = new UserService(getToken())
      service.updateName(this.user.id, {
        firstName: this.firstName,
        lastName: this.lastName
      }).then(async () => {
        const updatedUser = { ...this.user, first_name: this.firstName, last_name: this.lastName }
        saveUser(updatedUser)
        store.setUserAction(updatedUser)
        this.user = updatedUser
        this.showSnackbar('Nome atualizado com sucesso!')
      }).catch(err => {
        this.showSnackbar(err.response?.data?.detail || 'Erro ao atualizar nome', 'error')
      }).finally(() => {
        this.savingName = false
      })
    },
    savePassword() {
      if (!this.$refs.passwordForm.validate()) return

      this.savingPassword = true
      const service = new UserService(getToken())
      service.changePassword(this.user.id, {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then(() => {
        this.$refs.passwordForm.reset()
        this.showSnackbar('Senha alterada com sucesso!')
      }).catch(err => {
        this.showSnackbar(err.response?.data?.detail || 'Erro ao alterar senha', 'error')
      }).finally(() => {
        this.savingPassword = false
      })
    },
    showSnackbar(text, color = 'success') {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  },
  async mounted() {
    this.user = await getUser()
    this.firstName = this.user.first_name || ''
    this.lastName = this.user.last_name || ''
  }
}
</script>
